<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm12>
          <v-btn
            depressed
            :outline="filterType != 'gender'"
            :color="filterType == 'gender' ? 'primary' : 'grey'"
            @click="filterType = 'gender'"
            class="ma-0 mr-1 mb-1"
          >
            {{ $t('Gender') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filterType != 'age'"
            :color="filterType == 'age' ? 'primary' : 'grey'"
            @click="filterType = 'age'"
            class="ma-0 mr-1 mb-1"
          >
            {{ $t('Age') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter :defaultFilter="'last_7_days'" v-model="selectedDate"></date-filter>
    </div>

    <div class="mt-5">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm12>
          <PurchaseByGender
            v-if="filterType == 'gender'"
            :selectedDate="selectedDate"
          ></PurchaseByGender>
          <PurchaseByAge v-if="filterType == 'age'" :selectedDate="selectedDate"></PurchaseByAge>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import OverviewFilter from './OverviewFilter.vue'
import PurchaseByGender from './PurchaseByGender.vue'
import PurchaseByAge from './PurchaseByAge.vue'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    apexchart: VueApexCharts,
    OverviewFilter,
    PurchaseByAge,
    PurchaseByGender
  },
  data() {
    return {
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      filterType: 'gender',
      search: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/Overview1.vue